import "./About.module.css";
import Header from "@/reusable_sections/Header";
import AboutUs from "./sections/AboutUs";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <AboutUs />
      <Footer />
    </div>;
}